import { render, staticRenderFns } from "./one_header.vue?vue&type=template&id=c812dc0a&scoped=true"
import script from "./one_header.vue?vue&type=script&lang=js"
export * from "./one_header.vue?vue&type=script&lang=js"
import style0 from "./one_header.vue?vue&type=style&index=0&id=c812dc0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c812dc0a",
  null
  
)

export default component.exports